// extracted by mini-css-extract-plugin
export default {"p":"p--xX8PYFQT1xhxV0RDPFIQ"};